import 'reakit/styled';
import { palette, theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import { darken } from 'polished';
import _Code from 'reakit/Code';

var Code = styled(_Code).withConfig({
  displayName: "styled__Code",
  componentId: "sc-1otm95n-0"
})(["background-color:", ";border-radius:0.1rem;color:", ";font-family:'SF Mono','Segoe UI Mono','Roboto Mono',Menlo,Courier,monospace;code&{padding:0.1rem 0.2rem;", ";}pre&{padding:1rem;", ";}&{", ";}"], darken(0.05, 'white'), palette('text'), theme('fannypack.Code.inline'), theme('fannypack.Code.block'), theme('fannypack.Code.base'));

export default Code;
export { Code };
